import React from 'react';
import { nextLabel } from '../gameFlow';

/**
 * LE BOUTON QUI FAIT AVANCER, pour les écrans qui n'ont rien à valider.
 *
 * Les pages à décisions gardent le leur : il porte leurs contraintes (« Valider »
 * désactivé tant que le seuil n'est pas tenu). Celui-ci ne fait que dépiler, et
 * il existe pour les écrans custom — les bilans de fin d'atelier.
 *
 * POURQUOI CES ÉCRANS EN ONT BESOIN. Ils n'en avaient aucun : un bilan était
 * une page HORS PILE, affichée seulement une fois la partie finie, donc sans
 * suite possible. Depuis que la conclusion est la dernière page de la pile
 * (cf. gameFlow.js), un bilan est une page comme une autre — et une page sans
 * bouton est une séance qui ne peut pas se terminer, donc qui n'entre jamais
 * dans l'historique de l'animateur ni dans les statistiques.
 */
const AdvanceButton = ({ pageData, onDecisionSelect, displayButton = true, endsGame = false }) => {
  if (!displayButton || typeof onDecisionSelect !== 'function') return null;
  return (
    <button
      className="blue-button"
      onClick={() =>
        onDecisionSelect({
          page_id: pageData?._id,
          page_type: pageData?.type || 'custom',
          // Transmise bien que le serveur l'ignore aujourd'hui pour les pages
          // sans décision (`update_no_action_page` se contente de dépiler) :
          // l'omettre ferait de cet écran le seul à ne pas la remonter le jour
          // où ce trou sera bouché.
          page_general_consequence: pageData?.page_general_consequence,
        })
      }
    >
      {nextLabel(endsGame)}
    </button>
  );
};

export default AdvanceButton;
